import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useCurrentUser } from "../UserProvider";

export default function PrivateRoute() {
  const location = useLocation();
  const { currentUser, loading } = useCurrentUser(); // consume from UserProvider

  const token = !!localStorage.getItem('refresh_token');

  if (!token && !loading) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  // if (currentUser && currentUser.onboarding_done === false && !location.pathname.startsWith('/onboarding')) {
  //   return <Navigate to="/onboarding" replace />;
  // }

  return <Outlet />;
}